import Mapbox from "@components/mapbox/mapbox";

customElements.define('map-box', Mapbox)